import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { isRtl, LocaleContext } from '../../../i18n/src';
import { ICON_MAP } from './icon.map';
import { ICON_COLOR_MAP, ICON_SIZES_MAP } from './icon.types';
/**
 * Icons provide a visual language that quickly communicates actions. They can be informational or interactive.
 */
export const Icon = ({ name, color = 'gray', onClick, size = 'base' }) => {
    const locale = useContext(LocaleContext);
    const iconColor = ICON_COLOR_MAP[color];
    const { IconComponent } = ICON_MAP[name];
    /**
     * We define if the icon needs to be rotated or reversed based on the current locale and the icon configuration.
     * vertical reverse: the icon will be flipped vertically, but it will not support LTR as there are no current needs for this
     */
    const getOrientationStyles = () => {
        const rtl = ICON_MAP[name].supportsRTL && isRtl(locale);
        if (ICON_MAP[name].verticalReverse ||
            (ICON_MAP[name].horizontalReverse && !rtl) ||
            (!ICON_MAP[name].horizontalReverse && rtl)) {
            return 'nucleus-transform nucleus-rotate-180';
        }
        return '';
    };
    return (_jsx(IconComponent, { className: `nucleus-inline-block nucleus-box-border nucleus-align-middle ${iconColor} ${getOrientationStyles()} ${typeof size === 'string' ? ICON_SIZES_MAP[size] : ''} ${onClick ? 'nucleus-cursor-pointer' : ''}`, name: name, size: typeof size === 'number' ? size : undefined, role: 'img', onClick: onClick }));
};
//# sourceMappingURL=icon.component.js.map